import { render } from "./SpinnerLoading.vue?vue&type=template&id=5b00ec6a&ts=true"
import script from "./SpinnerLoading.vue?vue&type=script&lang=ts"
export * from "./SpinnerLoading.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__